'use strict';

// I'll need to fix first 'isomorphic-fetch' to be transpiled using
// babel-runtime before remove this line of code.

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('core-js/es6/promise');

var isFinite = require('lodash/isFinite');
var log = require('../utils/logger')('splitio-client');
var evaluator = require('../engine/evaluator');

var PassTracker = require('../tracker/PassThrough');
var tracker = require('../utils/timeTracker');

var keyParser = require('../utils/key/parser');

var thenable = require('../utils/promise/thenable');

var _require = require('../utils/key/factory'),
    matching = _require.matching,
    bucketing = _require.bucketing;

function getTreatmentAvailable(evaluation, splitName, key, stopLatencyTracker, impressionsTracker) {
  var matchingKey = matching(key);
  var bucketingKey = bucketing(key);

  var treatment = evaluation.treatment,
      label = evaluation.label,
      changeNumber = evaluation.changeNumber;


  if (treatment !== 'control') {
    log.info('Split: ' + splitName + '. Key: ' + matchingKey + '. Evaluation: ' + treatment);
  } else {
    log.warn('Split ' + splitName + ' doesn\'t exist');
  }

  impressionsTracker({
    feature: splitName,
    keyName: matchingKey,
    treatment: treatment,
    time: Date.now(),
    bucketingKey: bucketingKey,
    label: label,
    changeNumber: changeNumber
  });

  stopLatencyTracker();

  return evaluation.treatment;
}

function ClientFactory(context) {
  var storage = context.get(context.constants.STORAGE);
  var metricCollectors = context.get(context.constants.COLLECTORS);
  var impressionsTracker = PassTracker(storage.impressions);

  return {
    getTreatment: function getTreatment(key, splitName, attributes) {
      var stopLatencyTracker = tracker.start(tracker.TaskNames.SDK_GET_TREATMENT, metricCollectors);
      var evaluation = evaluator(key, splitName, attributes, storage);

      if (thenable(evaluation)) {
        return evaluation.then(function (res) {
          return getTreatmentAvailable(res, splitName, key, stopLatencyTracker, impressionsTracker);
        });
      } else {
        return getTreatmentAvailable(evaluation, splitName, key, stopLatencyTracker, impressionsTracker);
      }
    },
    getTreatments: function getTreatments(key, splitNames, attributes) {
      var _this = this;

      var results = {};
      var thenables = [];
      var i = void 0;

      var _loop = function _loop() {
        var name = splitNames[i];
        // If we are on the browser, key was binded to the getTreatment method.
        var treatment = _this.isBrowserClient ? _this.getTreatment(name, attributes) : _this.getTreatment(key, name, attributes);

        if (thenable(treatment)) {
          // If treatment returns a promise as it is being evaluated, save promise for progress tracking.
          thenables.push(treatment);
          treatment.then(function (res) {
            // set the treatment on the cb;
            results[name] = res;
          });
        } else {
          results[name] = treatment;
        }
      };

      for (i = 0; i < splitNames.length; i++) {
        _loop();
      }

      if (thenables.length) {
        return _promise2.default.all(thenables).then(function () {
          // After all treatments are resolved, we return the mapping object.
          return results;
        });
      } else {
        return results;
      }
    },
    track: function track(key, trafficTypeName, eventTypeId, eventValue) {
      var matchingKey = void 0;
      try {
        matchingKey = keyParser(key).matchingKey;
      } catch (e) {
        log.warn('Attempting to track event with invalid key. Event will be discarded.');
        return false; // If the key is invalid, return false.
      }

      if (typeof trafficTypeName !== 'string' || typeof eventTypeId !== 'string') {
        log.warn('Attempting to track event but Traffic Type and/or Event Type are invalid. Event will be discarded.');
        return false; // If the trafficType or eventType are invalid, return false.
      }

      var timestamp = Date.now();
      // Values that are no doubles should be taken as 0 (@Pato's)
      var value = isFinite(eventValue) ? eventValue : 0;

      storage.events.track({
        eventTypeId: eventTypeId,
        trafficTypeName: trafficTypeName,
        value: value,
        timestamp: timestamp,
        key: matchingKey
      });

      log.info('Successfully qeued event of type "' + eventTypeId + '" for traffic type "' + trafficTypeName + '". Key: ' + matchingKey + '. Value: ' + value + '. Timestamp: ' + timestamp + '.');

      return true;
    }
  };
}

module.exports = ClientFactory;


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/client/client.js
// module id = 653
// module chunks = 10